import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var __Array = {
    checkboxGroupOptions: '_checkboxGroup',
    validation: '_arrayType',
};
var __Boolean = { checkboxOptions: '_checkbox' };
var __Number = {
    numberInputOptions: '_numberInput',
    ratingInputOptions: '_ratingInput',
    validation: '_numberType',
};
var __Object = { validation: '_objectType' };
var __String = {
    textInputOptions: '_textInput',
    radioGroupOptions: '_radioGroup',
    dropdownOptions: '_dropdown',
    dateTimeOptions: '_dateTimeInput',
    phoneInputOptions: '_phoneInput',
    dateInputOptions: '_dateInput',
    timeInputOptions: '_timeInput',
    datePickerOptions: '_datePicker',
};
var _actionProviderSPIConfig = { actionConfig: '_actionSPIConfig' };
var _actionSPIConfig = { icon: '_commonImage' };
var _adminConfigurableTextInput = {
    requiredSettings: 'google.protobuf.FieldMask',
    adminConfigurableSettings: 'google.protobuf.FieldMask',
};
var _andCondition = { conditions: '_conditionNode' };
var _api_Number = {
    minimum: 'google.protobuf.FloatValue',
    maximum: 'google.protobuf.FloatValue',
    multipleOf: 'google.protobuf.FloatValue',
};
var _apiArrayItems = { data: '_dataItems', dataItem: '_dataItem' };
var _app = {
    components: '_components',
    market: '_market',
    ownership: '_ownership',
};
var _appEmbedData = { image: '_media' };
var _arrayItems = {
    numberOptions: '_numberType',
    objectOptions: '_objectType',
};
var _arrayType = { items: '_arrayItems' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _authenticatorConfig = { expectedInputs: '_expectedInputs' };
var _background = { image: '_media' };
var _billing = {
    monthlyPrice: 'DOUBLE',
    yearlyPrice: 'DOUBLE',
    oneTimePrice: 'DOUBLE',
    meteredBilling: '_meteredBilling',
};
var _checkbox = { label: '_richContent' };
var _checkboxGroup = { description: '_richContent', options: '_option' };
var _commonImage = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _company = { activeSince: 'google.protobuf.Timestamp' };
var _component = { compData: '_componentData' };
var _componentData = {
    widgetComponentData: '_widgetComponentData',
    widgetOutOfIframeData: '_widgetOutOfIframeComponentData',
    studioWidgetComponentData: '_studioWidgetComponentData',
    shippingLabelCarrier: '_shippingLabelCarrierSpiConfig',
    fictionalShippingProvider: '_shippingProviderConfig',
    automationsActionProvider: '_actionProviderSPIConfig',
    identityAuthenticator: '_authenticatorConfig',
    devCenterTestingComponent: '_devCenterTestingComponentData',
    multilingualTranslationSchema: '_multilingualTranslationSchema',
    formTemplate: '_formTemplate',
    functionsShopPriceProvider: '_functionsShopPriceSpiConfig',
    function: '_function',
    papiProvider: '_pluginConfig',
    multilingualTranslationSchemaGroup: '_schemaGroup',
    editorReactComponent: '_editorReactComponent',
};
var _components = { components: '_component' };
var _conditionNode = { and: '_andCondition', or: '_orCondition' };
var _dataItem = { number: '_api_Number', arrayItems: '_apiArrayItems' };
var _dataItems = { items: 'Map#_dataItem' };
var _dateInput = { description: '_richContent' };
var _datePicker = { description: '_richContent' };
var _dateTimeInput = { description: '_richContent' };
var _description = { representativeImage: '_commonImage' };
var _design = { poll: '_pollDesign' };
var _devCenterTestingComponentData = {
    translatableMessageInOneOf: '_messageContainingTranslatables',
    translatableMessage: '_messageContainingTranslatables',
    mapOfTranslatableMessages: 'Map#_messageContainingTranslatables',
    translatableRichContent: '_richContent',
    nonTranslatableRichContent: '_richContent',
    richContentMap: 'Map#_richContent',
};
var _displayField = { richContentOptions: '_richContentOptions' };
var _donationInput = { description: '_richContent' };
var _dropdown = { description: '_richContent' };
var _editorElement = {
    data: 'Map#_dataItem',
    elements: 'Map#_elementItem',
    presets: 'Map#_presetItem',
    elementsDefaults: 'Map#_elementDefaults',
};
var _editorPresence = { presetsEditorPresence: '_presetEditorPresence' };
var _editorReactComponent = { editorElement: '_editorElement' };
var _elementDefaults = { elementsDefaults: 'Map#_elementDefaults' };
var _elementItem = { inlineElement: '_inlineElement' };
var _elementStyleDefaults = {
    elementsStyleDefaults: 'Map#_elementStyleDefaults',
};
var _expectedInputs = {
    expectedStartInputs: '_predefinedExpectedInput',
    expectedVerifyInputs: '_predefinedExpectedInput',
};
var _field = { inputOptions: '_inputField', displayOptions: '_displayField' };
var _fileUpload = { description: '_richContent' };
var _finishInstallationRequest = {};
var _finishInstallationResponse = {};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _formTemplate = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_field',
    deletedFields: '_field',
    rules: '_v2Rule',
    submitSettings: '_submitSettings',
};
var _function = { description: '_description' };
var _functionsShopPriceSpiConfig = {
    shopNumber: 'google.protobuf.DoubleValue',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getInstalledAppsRequest = {};
var _getInstalledAppsResponse = { installedApps: '_installedAppData' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _inlineElement = {
    data: 'Map#_dataItem',
    elements: 'Map#_elementItem',
    presets: 'Map#_presetItem',
    elementsDefaults: 'Map#_elementDefaults',
};
var _inputField = {
    stringOptions: '__String',
    numberOptions: '__Number',
    booleanOptions: '__Boolean',
    arrayOptions: '__Array',
    objectOptions: '__Object',
    wixFileOptions: '_wixFile',
    paymentOptions: '_payment',
    multilineAddressOptions: '_inputFieldMultilineAddress',
};
var _inputFieldMultilineAddress = {
    multilineAddressOptions: '_multilineAddress',
};
var _installedAppData = { app: '_app' };
var _installFromShareUrlRequest = {};
var _installFromShareUrlResponse = {};
var _installRequest = {};
var _installResponse = {};
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _market = { pricingModel: '_pricingModel' };
var _media = { duration: 'google.protobuf.DoubleValue' };
var _mediaItem = { image: '_upstreamWixCommonImage' };
var _messageContainingTranslatables = {
    innerTranslatableRichContent: '_richContent',
};
var _meteredBilling = {
    monthlyBaseFee: 'DOUBLE',
    additionalCharges: 'google.protobuf.DoubleValue',
};
var _multilineAddress = { description: '_richContent' };
var _multilingualTranslationSchema = { referenceData: '_schema' };
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _numberInput = {
    default: 'google.protobuf.DoubleValue',
    description: '_richContent',
};
var _numberType = {
    maximum: 'google.protobuf.DoubleValue',
    minimum: 'google.protobuf.DoubleValue',
    multipleOf: 'google.protobuf.DoubleValue',
    enum: 'google.protobuf.DoubleValue',
};
var _objectType = { properties: 'Map#_propertiesType' };
var _option = { media: '_mediaItem' };
var _orCondition = { conditions: '_conditionNode' };
var _ownership = { company: '_company' };
var _packageDimension = {
    width: 'DOUBLE',
    length: 'DOUBLE',
    height: 'google.protobuf.DoubleValue',
};
var _packageType = { dimension: '_packageDimension', image: '_image' };
var _payment = {
    checkboxGroupOptions: '_productCheckboxGroup',
    donationInputOptions: '_donationInput',
};
var _phoneInput = { description: '_richContent' };
var _plan = { billing: '_billing' };
var _pluginConfig = { startingEnforcementDate: 'google.protobuf.Timestamp' };
var _poll = { image: '_media', options: '_pollOption' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _pollOption = { image: '_media' };
var _predefinedExpectedInput = {
    configuration: '_predefinedExpectedInputConfiguration',
};
var _predefinedExpectedInputConfiguration = {
    textInput: '_adminConfigurableTextInput',
};
var _presetEditorPresence = { wixMediaThumbnail: '_commonImage' };
var _presetItem = { elementsStyleDefaults: 'Map#_elementStyleDefaults' };
var _pricingModel = { plans: '_plan' };
var _productCheckboxGroup = {
    description: '_richContent',
    options: '_productCheckboxGroupOption',
};
var _productCheckboxGroupOption = { media: '_mediaItem' };
var _propertiesType = {
    numberOptions: '_numberType',
    arrayOptions: '_arrayType',
};
var _radioGroup = { description: '_richContent' };
var _ratingInput = { description: '_richContent' };
var _rawHttpRequest = { body: 'BYTES' };
var _rawHttpResponse = { body: 'BYTES' };
var _richContent = { nodes: '_node', metadata: '_v1Metadata' };
var _richContentOptions = { richContent: '_richContent' };
var _schema = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: 'Map#_v1SchemaField',
};
var _schemaGroup = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _shippingLabelCarrierSpiConfig = { packageTypes: '_packageType' };
var _shippingProviderConfig = { shippingPrice: 'DOUBLE' };
var _signature = { description: '_richContent' };
var _studioWidgetComponentData = {
    widgetDisplay: '_widgetDisplay',
    editorPresence: '_editorPresence',
};
var _submitSettings = { thankYouMessageOptions: '_thankYouMessageOptions' };
var _textInput = { description: '_richContent' };
var _thankYouMessageOptions = { richContent: '_richContent' };
var _timeInput = { description: '_richContent' };
var _uninstallRequest = {};
var _uninstallResponse = {};
var _updateRequest = {};
var _updateResponse = {};
var _upstreamWixCommonImage = {
    urlExpirationDate: 'google.protobuf.Timestamp',
};
var _v1Metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _v1SchemaField = { index: 'google.protobuf.DoubleValue' };
var _v2Rule = { expression: '_conditionNode' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _widgetComponentData = { widgetDisplay: '_widgetDisplay' };
var _widgetDisplay = { price: 'google.protobuf.FloatValue' };
var _widgetOutOfIframeComponentData = { widgetData: '_widgetComponentData' };
var _wixFile = {
    fileUploadOptions: '_fileUpload',
    signatureOptions: '_signature',
};
function resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/site-apps-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/site-apps',
                destPath: '/api',
            },
            {
                srcPath: '/oauth/token-received',
                destPath: '/api/v1/site-apps/token-received',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/site-apps',
                destPath: '/api',
            },
            {
                srcPath: '/_api/site-apps-server',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/site-apps',
                destPath: '/api',
            },
            {
                srcPath: '/_api/site-apps-server',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/site-apps',
                destPath: '/api',
            },
            {
                srcPath: '/_api/site-apps-server',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/site-apps',
                destPath: '/api',
            },
            {
                srcPath: '/site-apps',
                destPath: '',
            },
            {
                srcPath: '/site-apps-server',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/apps/v1/post-installation',
                destPath: '/v1/post-installation',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps/v1/post-installation',
                destPath: '/v1/post-installation',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Install an app on a specific metaSite, if a version is provided then that version is installed, otherwise latest version will get installed.
 * The app(s) will get installed on the site that exists in the context
 */
export function install(payload) {
    var _a = serializer(_installRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_installResponse, {}).fromJSON;
    function __install(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'POST',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.Install',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/bulk-install',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __install.fromReq = fromReq;
    __install.__isAmbassador = true;
    return __install;
}
export function installFromShareUrl(payload) {
    var _a = serializer(_installFromShareUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_installFromShareUrlResponse, {}).fromJSON;
    function __installFromShareUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'POST',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.InstallFromShareUrl',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/install-from-share-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __installFromShareUrl.fromReq = fromReq;
    __installFromShareUrl.__isAmbassador = true;
    return __installFromShareUrl;
}
/**
 * Uninstall an app from a metaSite, regardless of the version installed
 * The app(s) will get removed from the site that exists in the context
 */
export function uninstall(payload) {
    var _a = serializer(_uninstallRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_uninstallResponse, {}).fromJSON;
    function __uninstall(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'POST',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.Uninstall',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/bulk-uninstall',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __uninstall.fromReq = fromReq;
    __uninstall.__isAmbassador = true;
    return __uninstall;
}
/**
 * Update the app's version on this metaSite, if version is provided then update to this version, otherwise install latest
 * The app will get update on the site that exists in the context
 */
export function update(payload) {
    var _a = serializer(_updateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'PATCH',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.Update',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/bulk-update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/**
 * Authenticate with OAuth2 provider for applications with OAuth2.
 * @deprecated It has been replaced with Install(), and will be removed on 2022-09-30.
 */
export function finishInstallation(payload) {
    var _a = serializer(_finishInstallationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_finishInstallationResponse, {}).fromJSON;
    function __finishInstallation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'POST',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.FinishInstallation',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/finish-installation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __finishInstallation.fromReq = fromReq;
    __finishInstallation.__isAmbassador = true;
    return __finishInstallation;
}
/**
 * get installed apps data of a site by metasite id
 * the metaSite id context is taken from the authorization header using sign instance
 * Deprecated by com.wixpress.devcenter.appsruntimereader.v1.getAppsRuntimeData
 * When calling with Scala, use prime app components fetcher in https://github.com/wix-private/server-infra/tree/master/framework/loom-prime/examples/prime-app-components-fetcher
 * @deprecated It has been replaced with com.wixpress.devcenter.appsruntimereader.v1.getAppsRuntimeData(), and will be removed on 2024-09-30.
 */
export function getInstalledApps(payload) {
    var _a = serializer(_getInstalledAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInstalledAppsResponse, {
        __Array: __Array,
        __Boolean: __Boolean,
        __Number: __Number,
        __Object: __Object,
        __String: __String,
        _actionProviderSPIConfig: _actionProviderSPIConfig,
        _actionSPIConfig: _actionSPIConfig,
        _adminConfigurableTextInput: _adminConfigurableTextInput,
        _andCondition: _andCondition,
        _apiArrayItems: _apiArrayItems,
        _api_Number: _api_Number,
        _app: _app,
        _appEmbedData: _appEmbedData,
        _arrayItems: _arrayItems,
        _arrayType: _arrayType,
        _audioData: _audioData,
        _authenticatorConfig: _authenticatorConfig,
        _background: _background,
        _billing: _billing,
        _checkbox: _checkbox,
        _checkboxGroup: _checkboxGroup,
        _commonImage: _commonImage,
        _company: _company,
        _component: _component,
        _componentData: _componentData,
        _components: _components,
        _conditionNode: _conditionNode,
        _dataItem: _dataItem,
        _dataItems: _dataItems,
        _dateInput: _dateInput,
        _datePicker: _datePicker,
        _dateTimeInput: _dateTimeInput,
        _description: _description,
        _design: _design,
        _devCenterTestingComponentData: _devCenterTestingComponentData,
        _displayField: _displayField,
        _donationInput: _donationInput,
        _dropdown: _dropdown,
        _editorElement: _editorElement,
        _editorPresence: _editorPresence,
        _editorReactComponent: _editorReactComponent,
        _elementDefaults: _elementDefaults,
        _elementItem: _elementItem,
        _elementStyleDefaults: _elementStyleDefaults,
        _expectedInputs: _expectedInputs,
        _field: _field,
        _fileUpload: _fileUpload,
        _focalPoint: _focalPoint,
        _formTemplate: _formTemplate,
        _function: _function,
        _functionsShopPriceSpiConfig: _functionsShopPriceSpiConfig,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _inlineElement: _inlineElement,
        _inputField: _inputField,
        _inputFieldMultilineAddress: _inputFieldMultilineAddress,
        _installedAppData: _installedAppData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _market: _market,
        _media: _media,
        _mediaItem: _mediaItem,
        _messageContainingTranslatables: _messageContainingTranslatables,
        _meteredBilling: _meteredBilling,
        _multilineAddress: _multilineAddress,
        _multilingualTranslationSchema: _multilingualTranslationSchema,
        _node: _node,
        _numberInput: _numberInput,
        _numberType: _numberType,
        _objectType: _objectType,
        _option: _option,
        _orCondition: _orCondition,
        _ownership: _ownership,
        _packageDimension: _packageDimension,
        _packageType: _packageType,
        _payment: _payment,
        _phoneInput: _phoneInput,
        _plan: _plan,
        _pluginConfig: _pluginConfig,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _pollOption: _pollOption,
        _predefinedExpectedInput: _predefinedExpectedInput,
        _predefinedExpectedInputConfiguration: _predefinedExpectedInputConfiguration,
        _presetEditorPresence: _presetEditorPresence,
        _presetItem: _presetItem,
        _pricingModel: _pricingModel,
        _productCheckboxGroup: _productCheckboxGroup,
        _productCheckboxGroupOption: _productCheckboxGroupOption,
        _propertiesType: _propertiesType,
        _radioGroup: _radioGroup,
        _ratingInput: _ratingInput,
        _richContent: _richContent,
        _richContentOptions: _richContentOptions,
        _schema: _schema,
        _schemaGroup: _schemaGroup,
        _shippingLabelCarrierSpiConfig: _shippingLabelCarrierSpiConfig,
        _shippingProviderConfig: _shippingProviderConfig,
        _signature: _signature,
        _studioWidgetComponentData: _studioWidgetComponentData,
        _submitSettings: _submitSettings,
        _textInput: _textInput,
        _thankYouMessageOptions: _thankYouMessageOptions,
        _timeInput: _timeInput,
        _upstreamWixCommonImage: _upstreamWixCommonImage,
        _v1Metadata: _v1Metadata,
        _v1SchemaField: _v1SchemaField,
        _v2Rule: _v2Rule,
        _video: _video,
        _videoData: _videoData,
        _widgetComponentData: _widgetComponentData,
        _widgetDisplay: _widgetDisplay,
        _widgetOutOfIframeComponentData: _widgetOutOfIframeComponentData,
        _wixFile: _wixFile,
    }).fromJSON;
    function __getInstalledApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'GET',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.GetInstalledApps',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/v1/site-apps/installed-apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                        protoPath: '/v1/site-apps/installed-apps',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getInstalledApps.fromReq = fromReq;
    __getInstalledApps.__isAmbassador = true;
    return __getInstalledApps;
}
export function tokenReceived(payload) {
    var _a = serializer(_rawHttpRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __tokenReceived(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.site_apps.v1.app',
            method: 'GET',
            methodFqn: 'com.wixpress.market.siteapps.api.SiteAppsInstallation.TokenReceived',
            url: resolveComWixpressMarketSiteappsApiSiteAppsInstallationUrl({
                protoPath: '/api/v1/site-apps/token-received',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __tokenReceived.fromReq = fromReq;
    __tokenReceived.__isAmbassador = true;
    return __tokenReceived;
}
//# sourceMappingURL=http.impl.js.map